import { render } from "./ReferenceField.vue?vue&type=template&id=a9b9495e&ts=true"
import script from "./ReferenceField.vue?vue&type=script&lang=ts"
export * from "./ReferenceField.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.3.0_webpack@5.92.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__